import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Cross = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { d: "m12.93 9.984 3.946-3.92c.817-.813.82-2.13.008-2.946a2.08 2.08 0 0 0-2.946-.009L9.984 7.04 6.06 3.109a2.09 2.09 0 0 0-2.95 0 2.09 2.09 0 0 0 0 2.95l3.917 3.917-3.908 3.883a2.086 2.086 0 0 0 2.937 2.958l3.921-3.895 3.95 3.95a2.093 2.093 0 0 0 2.95 0 2.085 2.085 0 0 0 0-2.946l-3.942-3.942z" }) }));
});
Cross.displayName = 'Cross';
Cross.__iconComponentType = 'standard';
export default Cross;
//# sourceMappingURL=Cross.js.map